module.exports = __webpack_public_path__ + "img/section1_tab1_img.61472867.svg";